import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import Me from "../helpers/me";
import App from "../helpers/app";
import Api from "../helpers/api";
import * as moment from "moment";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { take } from "rxjs/operators";
import Swal from "sweetalert2";
import { HttpClient } from "@angular/common/http";
import { ExcelService } from "../helpers/excel.service";
import { BreadcrumbService } from '../shared/services/breadcrumb.service';
import { MatriculaServidorHelper } from '../shared/services/matricula-servidor.helper';

@Component({
  selector: "app-servidores",
  templateUrl: "./servidores.component.html",
  styleUrls: ["./servidores.component.scss"],
})
export class ServidoresComponent implements OnInit {
  apiCall = this.api.new().silent();
  page = 1;
  pageSize = 10;
  total = 0; // Total de registros retornado pelo backend
  urlToShow = null;
  idCidade;
  cidade = null;
  nomeCidade : string;
  isAdmin = false;
  municipiosDisponiveis: { id: string; nome: string }[] = []; // opções do seletor (admin)
  filtroMunicipio = ""; // busca dentro da modal de municípios
  modalMunicipios = null; // referência da modal aberta (para fechar ao escolher)
  tempoTotalCadastrado = 0
  tempoFiltradoCadastrado= 0
  tipo;
  private filterTimeout: any; // Para debounce
  servidor = {
    cpf: null,
    cidade_naturalidade: null,
    data_ingresso_servico_publico: null,
    data_nascimento: null,
    deficiente: null,
    data_falecimento: null,
    documento_ingresso_servico_publico: null,
    escolaridade: null,
    estado_civil: null,
    estado_naturalidade: null,
    id_cidade: null,
    nacionalidade: null,
    naturalizado: null,
    nome: null,
    nome_mae: null,
    nome_pai: null,
    sexo: null,
    status: null,
    paridade_aposentadoria: null,
    concessao_aposentadoria: null,
    valor_aposentadoria: null,
    cargo_aposentadoria: null,
    pis_aposentado: null,
    tipo_aposentadoria: null,
    cpf_pensao: null,
    pis_pensao: null,
    nome_pensao: null,
    matricula_pensao: null,
    data_nascimento_pensao: null,
    data_falecimento_pensao: null,
    matricula_beneficiario: null,
    tipo_pensao: null,
    valor_beneficio: null,
    motivo_exoneracao: null,
    telefone: null,
    matricula: null,
    carga_horaria: null,
    imagem: null,
    rg: null,
    salario: null,
    cargo: null,
    data_ingresso_ente: null,
    statusNumero: null
  };



  tiposaposentadoria = [
    { name: "Aposentadoria por Idade", value: 1, group: "Para Civis" },
    {
      name: "Aposentadoria por Tempo de Contribuição",
      value: 2,
      group: "Para Civis",
    },
    { name: 'Aposentadoria por tempo de contribuição e idade', value: 10, group: 'Para Civis' },
    { name: "Aposentadoria Compulsória", value: 3, group: "Para Civis" },
    { name: "Aposentadoria por Invalidez", value: 4, group: "Para Civis" },
    { name: "Aposentadoria como Professor", value: 5, group: "Para Civis" },
    {
      name: "Aposentadoria Especial - atividade de risco (Art. 40, § 4o, inc. II, CF)",
      value: 6,
      group: "Para Civis",
    },
    {
      name: "Aposentadoria Especial - atividade prejudiciais à saúde ou integridade física (Art. 40, § 4o, inc. III, CF)",
      value: 7,
      group: "Para Civis",
    },
    {
      name: "Militares Inativos - Reserva Remunerada",
      value: 8,
      group: "Militares Inativos",
    },
    {
      name: "Militares Inativos - Reforma",
      value: 9,
      group: "Militares Inativos",
    },
  ];
  servidores = [];
  selectedItems: boolean[] = [false, false, false, false];
  servidoresFiltered = [];
  servidoresExpandidos: { [key: string]: boolean } = {};
  filters = [
    "cpf",
    "matricula",
    "data de nascimento",
    "data de cadastro",
    "status",
    "nome",
  ];
  tipospensao = [
    { name: "Vitalícia", value: 1 },
    { name: "Temporária", value: 2 },
  ];
  selectedFilter = null;
  statusServidor = [
    {
      id: 1,
      name: "Ativo",
    },
    {
      id: 2,
      name: "Aposentado",
    },
    {
      id: 3,
      name: "Pensionista",
    },
    {
      id: 4,
      name: "Exonerado",
    },
    {
      id: 5,
      name: "Falecido",
    },
  ];
  sexos = [
    {
      id: "M",
      name: "Masculino",
    },
    {
      id: "F",
      name: "Feminino",
    },
  ];
  naturalizados = [
    {
      id: 1,
      name: "Sim",
    },
    {
      id: 2,
      name: "Não",
    },
  ];
  estados = [];
  cidades = [];
  estadosCivis = [];
  dependentes = [];
  dependentesToShow = [];
  escolaridades = [];
  tiposDependencia = [];
  planilhas = [];
  tempos = [];
  status = [
    {
      id: true,
      name: "Ativo",
    },
    {
      id: false,
      name: "Inativo",
    },
  ];
  filterName;
  filterCpf;
  filterMatricula;
  filterNascimento;
  filterCadastro;
  filterSexo;
  filterStatus;
  filterCreatedAt = {
    start: '',
    end: ''
  };

  filterBirthDate = {
    start: '',
    end: ''
  };
  filterDiverso = null;
  filtrosDiversosOpcoes = [
    { id: 'uma', name: 'Uma matrícula' },
    { id: 'multiplas', name: 'Múltiplas matrículas' },
    { id: 'com_dependentes', name: 'Servidores com dependentes' },
    { id: 'dependentes_deficientes', name: 'Servidores com dependentes deficientes' },
    { id: 'dependentes_maior_21', name: 'Servidores com dependentes maiores de 21 anos' },
  ];
  colunasEsperadasInativos = [
    "NU_ANO",
    "CO_IBGE",
    "NO_ENTE",
    "SG_UF",
    "CO_COMP_MASSA",
    "CO_TIPO_FUNDO",
    "CNPJ_ORGAO",
    "NO_ORGAO",
    "CO_PODER",
    "CO_TIPO_PODER",
    "CO_TIPO_POPULACAO",
    "CO_TIPO_CARGO",
    "CO_TIPO_APOSENTADORIA",
    "ID_APOSENTADO_MATRICULA",
    "ID_APOSENTADO_CPF",
    "ID_APOSENT_PIS_PASEP",
    "CO_SEXO_APOSENTADO",
    "CO_EST_CIVIL_APOSENTADO",
    "DT_NASC_APOSENTADO",
    "DT_INICIO_APOSENTADORIA",
    "VL_APOSENTADORIA",
    "VL_CONTRIBUICAO",
    "IN_PARID_SERV",
    "CO_CONDICAO_APOSENTADO",
    "VL_COMPENS_PREVID",
    "NU_DEPENDENTES",
    "DT_NASC_CONJUGE",
    "CO_CONDICAO_CONJUGE",
    "DT_NASC_DEPENDENTE_1",
    "CO_CONDICAO_DEPENDENTE_1",
    "DT_NASC_DEPENDENTE_2",
    "CO_CONDICAO_DEPENDENTE_2",
  ];

  colunasEsperadasAposentados = [
    "NU_ANO",
    "CO_IBGE",
    "NO_ENTE",
    "SG_UF",
    "CO_COMP_MASSA",
    "CO_TIPO_FUNDO",
    "CNPJ_ORGAO",
    "NO_ORGAO",
    "CO_PODER",
    "CO_TIPO_PODER",
    "CO_TIPO_INSTITUIDOR",
    "ID_INSTITUIDOR_MATRICULA",
    "ID_INSTITUIDOR_CPF",
    "ID_INSTITUIDOR_PIS_PASEP",
    "ID_PENSIONISTA_CPF",
    "CO_SEXO_PENSIONISTA",
    "DT_NASC_PENSIONISTA",
    "DT_INICIO_PENSAO",
    "VL_BENEF_PENSAO",
    "VL_CONTRIBUICAO",
    "VL_COMPENS_PREVID",
    "IN_PARID_SERV",
    "CO_CONDICAO",
    "CO_DURACAO",
  ];
  colunasEsperadasSimplificado = [
    "CO_IBGE",
    "ID_SERVIDOR_MATRICULA",
    "ID_SERVIDOR_CPF",
    "STATUS_SERVIDOR",
    "NOME_SERVIDOR"
  ]
  colunasEsperadasIdadeAposentadoria = [
    "CO_IBGE",
    "SERVIDOR_MATRICULA",
    "SERVIDOR_IDADE",
  ]
  colunasEsperadasAtivos = [
    "NU_ANO",
    "CO_IBGE",
    "NO_ENTE",
    "SG_UF",
    "CO_COMP_MASSA",
    "CO_TIPO_FUNDO",
    "NU_CNPJ_ORGAO",
    "NO_ORGAO",
    "CO_PODER",
    "CO_TIPO_PODER",
    "CO_TIPO_POPULACAO",
    "CO_TIPO_CARGO",
    "CO_CRITERIO_ELEGIBILIDADE",
    "ID_SERVIDOR_MATRICULA",
    "ID_SERVIDOR_CPF",
    "ID_SERVIDOR_PIS_PASEP",
    "CO_SEXO_SERVIDOR",
    "CO_EST_CIVIL_SERVIDOR",
    "DT_NASC_SERVIDOR",
    "CO_SITUACAO_FUNCIONAL",
    "CO_TIPO_VINCULO",
    "DT_ING_SERV_PUB",
    "DT_ING_ENTE",
    "DT_ING_CARREIRA",
    "NO_CARREIRA",
    "DT_ING_CARGO",
    "NO_CARGO",
    "VL_BASE_CALCULO",
    "VL_REMUNERACAO",
    "NU_TEMPO_RGPS",
    "NU_TEMPO_RPPS",
    "NU_DEPENDENTES",
    "DT_NASC_CONJUGE",
    "CO_COND_CONJUGE",
    "DT_NASC_DEPENDENTE_1",
    "CO_COND_DEPENDENTE_1",
    "DT_NASC_DEPENDENTE_2",
    "CO_COND_DEPENDENTE_2",
    "IN_ABONO_PERMANENCIA",
    "DT_INICIO_ABONO",
    "DT_PROV_APOSENT",
  ];

  sortColumn: string = '';
  sortDirection: string = 'asc'; 
  constructor(
    private router: Router,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private excelService: ExcelService,
    private route: ActivatedRoute,
    private me: Me,
    private app: App,
    private http: HttpClient,
    private api: Api,
    private breadcrumbService: BreadcrumbService
  ) {}



  selectFilter(event) { 
    this.filterName = null;
    this.filterCpf = null;
    this.filterMatricula = null;
    this.filterNascimento = null;
    this.filterCadastro = null;
    this.filterSexo = null;
    this.filterStatus = null;
    this.loadServidores();
  }

  /**
   * Constrói os parâmetros de query para a requisição ao backend
   */
  private buildQueryParams(): string {
    const params = new URLSearchParams();
    
    // Parâmetro obrigatório
    params.append('id_cidade', this.idCidade.toString());
    
    // Parâmetros de paginação
    const offset = (this.page - 1) * this.pageSize;
    params.append('offset', offset.toString());
    params.append('limit', this.pageSize.toString());
    
    // Filtros opcionais
    if (this.filterName && this.filterName.trim()) {
      params.append('nome', this.filterName.trim());
    }
    
    if (this.filterCpf && this.filterCpf.trim()) {
      // Remove caracteres não numéricos do CPF
      const cpfLimpo = this.filterCpf.toString().replace(/[^\d]/g, '');
      if (cpfLimpo) {
        params.append('cpf', cpfLimpo);
      }
    }
    
    if (this.filterMatricula && this.filterMatricula.toString().trim()) {
      params.append('matricula', this.filterMatricula.toString().trim());
    }
    
    if (this.filterStatus) {
      params.append('status', this.filterStatus.toString());
    }
    
    // Filtro de data de cadastro - range (inicio e fim)
    if (this.filterCreatedAt.start && this.filterCreatedAt.start.trim()) {
      params.append('data_cadastro_inicio', this.filterCreatedAt.start.trim());
    }
    if (this.filterCreatedAt.end && this.filterCreatedAt.end.trim()) {
      params.append('data_cadastro_fim', this.filterCreatedAt.end.trim());
    }
    
    // Filtro de data de nascimento - range (inicio e fim)
    if (this.filterBirthDate.start && this.filterBirthDate.start.trim()) {
      params.append('data_nascimento_inicio', this.filterBirthDate.start.trim());
    }
    if (this.filterBirthDate.end && this.filterBirthDate.end.trim()) {
      params.append('data_nascimento_fim', this.filterBirthDate.end.trim());
    }

    // Filtros diversos (select único)
    if (this.filterDiverso) {
      // 'uma'/'multiplas' reutilizam o filtro de quantidade de matrículas;
      // os demais são filtros por dependentes.
      if (this.filterDiverso === 'uma' || this.filterDiverso === 'multiplas') {
        params.append('quantidade_matriculas', this.filterDiverso);
      } else {
        params.append('filtro_dependentes', this.filterDiverso);
      }
    }

    // Parâmetros de ordenação
    if (this.sortColumn) {
      // Mapear colunas do frontend para colunas do backend
      const orderByMap: { [key: string]: string } = {
        'nome': 'nome',
        'cpf': 'cpf',
        'matricula': 'matricula',
        'status': 'status'
      };
      
      const orderBy = orderByMap[this.sortColumn];
      if (orderBy) {
        params.append('orderBy', orderBy);
        params.append('orderDirection', this.sortDirection.toUpperCase());
      }
    }
    
    return params.toString();
  }

  /**
   * Carrega servidores do backend com paginação e filtros
   */
  async loadServidores() {
    const self = this;
    
    if (!self.idCidade) {
      return;
    }

    self.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });

    try {
      const queryParams = self.buildQueryParams();
      const response = await self.apiCall
        .get(`servidor/todos/cidade?${queryParams}`)
        .pipe(take(1))
        .toPromise();

      const data = response ? JSON.parse(JSON.stringify(response)) : { rows: [], total: 0 };
      
      let lista = data.rows ? MatriculaServidorHelper.normalizarLista(data.rows, self.idCidade) : [];
      let listafinal = [];
      
      if (lista.length > 0) {
        // Se houver ordenação específica selecionada pelo usuário, manter a ordem do backend
        // Caso contrário, aplicar lógica de ordenação especial (pendencias primeiro, etc)
        if (self.sortColumn) {
          // Ordenação específica: usar dados do backend como estão
          listafinal = [...lista];
        } else {
          // Sem ordenação específica: aplicar lógica de ordenação especial
          let lista1 = lista.filter(x => x.temDependenteMaiorDe21);
          let lista2 = lista.filter(x => x.temTetoINSS);
          let lista3 = lista.filter(x => x.pendencias);
          listafinal = [...lista1];
          
          for (let l of lista2) {
            if (!listafinal.find(x => x == l)) {
              listafinal.push(l);
            }
          }
          
          for (let l of lista3) {
            if (!listafinal.find(x => x == l)) {
              listafinal.push(l);
            }
          }
          
          for (let l of lista) {
            if (!listafinal.find(x => x == l)) {
              listafinal.push(l);
            }
          }
        }
        
        for (let l of listafinal) {
          l.duasmatriculas = MatriculaServidorHelper.temMultiplasMatriculas(l, self.idCidade);
        }
      }

      self.servidores = [...listafinal];
      self.servidoresFiltered = [...listafinal];
      self.servidoresExpandidos = {};
      self.total = data.total || 0;
      
      self.spinner.hide();
    } catch (error) {
      console.error('Erro ao carregar servidores:', error);
      self.servidores = [];
      self.servidoresFiltered = [];
      self.total = 0;
      self.spinner.hide();
    }
  }
  beautifulUrl(url) {
    if (url) {
      return url.replace(
        "https://cadastro-pessoas-arquivos-servidor.s3.amazonaws.com/",
        ""
      );
    } else {
      return "";
    }
  }
  async ngOnInit() {
    const self = this;
    self.servidor = {
      cpf: null,
      cidade_naturalidade: null,
      data_ingresso_servico_publico: null,
      data_nascimento: null,
      deficiente: null,
      documento_ingresso_servico_publico: "",
      escolaridade: null,
      data_falecimento: null,
      estado_civil: null,
      estado_naturalidade: null,
      id_cidade: null,
      nacionalidade: null,
      naturalizado: null,
      nome: null,
      nome_mae: null,
      nome_pai: null,
      sexo: null,
      status: null,
      paridade_aposentadoria: null,
      concessao_aposentadoria: null,
      valor_aposentadoria: null,
      cargo_aposentadoria: null,
      pis_aposentado: null,
      tipo_aposentadoria: null,
      cpf_pensao: null,
      pis_pensao: null,
      nome_pensao: null,
      matricula_pensao: null,
      data_nascimento_pensao: null,
      data_falecimento_pensao: null,
      matricula_beneficiario: null,
      tipo_pensao: null,
      valor_beneficio: null,
      motivo_exoneracao: null,
      telefone: null,
      matricula: null,
      carga_horaria: null,
      imagem: null,
      rg: null,
      salario: null,
      cargo: null,
      data_ingresso_ente: null,
      statusNumero: null
    };
    self.tempoTotalCadastrado = 0
    self.estados = [];
    self.cidades = [];
    self.estadosCivis = [];
    self.escolaridades = [];
    const dadosUsuario = self.me.currentUserValue;
    const json = JSON.parse(JSON.stringify(dadosUsuario));
    const cidade = json.user.cidade;
    console.log('json.user', json.user)
    self.nomeCidade = json.user.nomeCidade;
    self.isAdmin = json.user.tipo === "1";
    if (cidade) {
      self.idCidade = cidade;
    }

    if (json.user.tipo === "1") {
      console.log("caiu if")
      self.route.queryParams.subscribe(async (parametros) => {
        if (parametros["idCidade"]) {
          let idCidade = parametros["idCidade"];
          self.idCidade = idCidade;
          json.user.cidade = idCidade;
          self.me.atualizaCidade(json);
          
          // Configurar breadcrumbs como componente filho - SEMPRE 3 níveis para admin
          self.breadcrumbService.setMunicipioBreadcrumbs('Servidores', Number(idCidade));
          
          const planilhas = await self.apiCall
            .get("servidor/arquivo/planilha?id_cidade=" + self.idCidade)
            .pipe(take(1))
            .toPromise();
          const responseCidade = await self.apiCall
            .get("enderecos/cidade?id=" + self.idCidade)
            .pipe(take(1))
            .toPromise();
          self.planilhas = JSON.parse(JSON.stringify(planilhas));
          if (responseCidade && responseCidade[0]) {
            self.cidade = responseCidade[0];
            self.nomeCidade = self.cidade.nome;
          }
          
          // Resetar página e carregar servidores
          self.page = 1;
          await self.loadServidores();
        } else if (cidade) {
          // Sem idCidade na URL, mas temos o município persistido (ex: voltando
          // da tela de um servidor). Restaura o parâmetro na URL para não perder
          // a referência; isso redispara este subscribe já com o idCidade e
          // executa o fluxo completo acima (breadcrumbs, cidade, planilhas...).
          self.router.navigate([], {
            relativeTo: self.route,
            queryParams: { idCidade: cidade },
            queryParamsHandling: 'merge',
          });
        } else {
          console.log("caiu else")
          // Nenhum município selecionado nem persistido.
          // Configurar breadcrumbs como componente filho - 3 níveis para não-admin também
          self.breadcrumbService.setMunicipioBreadcrumbs('Servidores');

          const planilhas = await self.apiCall
            .get("servidor/arquivo/planilha?id_cidade=" + cidade)
            .pipe(take(1))
            .toPromise();
          self.planilhas = JSON.parse(JSON.stringify(planilhas));

          // Resetar página e carregar servidores
          self.page = 1;
          await self.loadServidores();
        }
      });
    } else {
      console.log("Else do else")
      const planilhas = await self.apiCall
        .get("servidor/arquivo/planilha?id_cidade=" + cidade)
        .pipe(take(1))
        .toPromise();
      self.planilhas = JSON.parse(JSON.stringify(planilhas));
      
      // Resetar página e carregar servidores
      self.page = 1;
      await self.loadServidores();
    }

    const estados = await self.apiCall
      .get("enderecos/estados")
      .pipe(take(1))
      .toPromise();
    self.estados = JSON.parse(JSON.stringify(estados));
    const escolaridades = await self.apiCall
      .get("servidor/escolaridade")
      .pipe(take(1))
      .toPromise();
    self.escolaridades = JSON.parse(JSON.stringify(escolaridades));
    const estadosCivis = await self.apiCall
      .get("servidor/estadocivil")
      .pipe(take(1))
      .toPromise();
    self.estadosCivis = JSON.parse(JSON.stringify(estadosCivis));

    // Lista de municípios para o seletor (apenas admin pode trocar de cidade)
    if (self.isAdmin) {
      await self.carregarMunicipios();
    }
  }

  // Monta a lista única de municípios a partir dos usuários (mesma fonte da
  // home do admin), para alimentar o seletor de cidades.
  async carregarMunicipios() {
    const self = this;
    try {
      const data = await self.apiCall
        .get("users/lista/servidor")
        .pipe(take(1))
        .toPromise();
      const usuarios = (JSON.parse(JSON.stringify(data)) as any[]) || [];
      const mapa = new Map<string, { id: string; nome: string }>();
      for (const u of usuarios) {
        if (u.cidade && u.nomeCidade && !mapa.has(String(u.cidade))) {
          mapa.set(String(u.cidade), { id: String(u.cidade), nome: u.nomeCidade });
        }
      }
      self.municipiosDisponiveis = Array.from(mapa.values()).sort((a, b) =>
        a.nome.localeCompare(b.nome)
      );
    } catch (e) {
      self.municipiosDisponiveis = [];
    }
  }

  // Abre a modal de troca de município (acionada ao clicar no nome da cidade).
  openModalMunicipios(content) {
    this.filtroMunicipio = "";
    this.modalMunicipios = this.modalService.open(content, {
      centered: true,
      scrollable: true,
    });
  }

  // Lista de municípios filtrada pelo termo digitado na modal.
  municipiosFiltrados() {
    const termo = (this.filtroMunicipio || "").trim().toLowerCase();
    if (!termo) return this.municipiosDisponiveis;
    return this.municipiosDisponiveis.filter((m) =>
      m.nome.toLowerCase().includes(termo)
    );
  }

  // Troca de município sem sair da tela: apenas atualiza o idCidade na URL.
  // O subscribe de queryParams já existente recarrega breadcrumbs, cidade,
  // planilhas e a lista de servidores automaticamente.
  trocarCidade(novoIdCidade) {
    if (this.modalMunicipios) {
      this.modalMunicipios.close();
      this.modalMunicipios = null;
    }
    if (!novoIdCidade || String(novoIdCidade) === String(this.idCidade)) return;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { idCidade: novoIdCidade },
      queryParamsHandling: "merge",
    });
  }

  openModalXl(content) {
    const modal = this.modalService.open(content, {
      centered: true,
      size: "xl",
    });
  }
  toggleSelected(index: number) {
    for (let i = 0; i < this.selectedItems.length; i++) {
      this.selectedItems[i] = (i === index) && !this.selectedItems[index];
    }
    
    // Aplicar filtros locais nos dados já carregados
    // Nota: Esses filtros especiais não são suportados pelo backend,
    // então são aplicados apenas nos dados da página atual
    this.servidoresFiltered = [...this.servidores];
    
    if(this.selectedItems[0]){
      this.servidoresFiltered = this.servidoresFiltered.filter(
        (x) => x.pendencias
      );
    }
    if(this.selectedItems[1]){
      this.servidoresFiltered = this.servidoresFiltered.filter(
        (x) => x.temDependenteMaiorDe21
      );
    }
    if(this.selectedItems[2]){
      this.servidoresFiltered = this.servidoresFiltered.filter(
        (x) => x.temTetoINSS
      );
    }
    if(this.selectedItems[3]){
      this.servidoresFiltered = this.servidoresFiltered.filter(
        (x) => x.duasmatriculas
      );
      this.servidoresFiltered.sort((a, b) => a.nome.localeCompare(b.nome));
    }
    
    // Atualizar total para refletir os filtros locais
    // Como são filtros locais, o total será o tamanho do array filtrado
    this.total = this.servidoresFiltered.length;
  }
  getYear(data){
    return moment(data).format('YYYY')
  }
  classificaStatus(status){
    if(!status){
      return ''
    }
    if(status==1){
      return 'Ativo'
    }
    if(status==2){
      return 'Aposentado'
    }
    if(status==3){
      return 'Pensionista'
    }
    if(status==4){
      return 'Exonerado'
    }
    if(status==5){
      return 'Falecido'
    }
  }

  getMatriculasServidor(servidor: any): any[] {
    return MatriculaServidorHelper.getMatriculas(servidor, this.idCidade);
  }
  getMatriculasReaisServidor(servidor: any): any[] {
    return this.getMatriculasServidor(servidor)
      .filter(matricula => !MatriculaServidorHelper.isTemporaria(matricula));
  }

  isMatriculaTemporaria(matricula: any): boolean {
    return MatriculaServidorHelper.isTemporaria(matricula);
  }


  getStatusServidor(servidor: any): number[] {
    return this.getMatriculasServidor(servidor)
      .map(matricula => +matricula.status)
      .filter((status, index, statuses) => !!status && statuses.indexOf(status) === index);
  }

  getStatusClass(status: number): string {
    return `status-${status}`;
  }

  private getServidorKey(servidor: any): string {
    return String(servidor && (servidor.id || servidor.cpf));
  }

  toggleServidor(servidor: any) {
    const key = this.getServidorKey(servidor);
    const estavaExpandido = !!this.servidoresExpandidos[key];
    this.servidoresExpandidos = estavaExpandido ? {} : { [key]: true };
  }

  isServidorExpanded(servidor: any): boolean {
    return !!this.servidoresExpandidos[this.getServidorKey(servidor)];
  }
  viewMidia(urlToShow, content) {
    this.urlToShow = urlToShow;
    this.modalService.open(content, { centered: true });
  }
  //var csv is the CSV file with headers
  csvJSON(csv) {
    let lines = csv.split("\r\n");

    if(lines.length==1){
    lines = csv.split("\n");
    }

    var result = [];

    console.log(lines)

    // NOTE: If your columns contain commas in their values, you'll need
    // to deal with those before doing the next step
    // (you might convert them to &&& or something, then covert them back later)
    // jsfiddle showing the issue https://jsfiddle.net/
    var headers = lines[0].split(";");
    for (var i = 1; i < lines.length; i++) {
      var obj = {};
      var currentline = lines[i].split(";");
      if (currentline.length > 1) {
        for (var j = 0; j < headers.length; j++) {
          obj[headers[j]] = currentline[j];
        }
        result.push(obj);
      }
    }

    //return result; //JavaScript object
    return JSON.stringify(result); //JSON
  }
  getColor(servidor){
    if(servidor.pendencias){
      return '#ffcfcf'
    }
    if(servidor.temDependenteMaiorDe21){
      return '#ffffcb'
    }
    if(servidor.temTetoINSS){
      return '#d9eeff'
    }
    return 'none'
  }
  async selecionaArquivo(type) {
    const self = this;
    const { value: file } = await Swal.fire({
      title:
        type == 1
          ? "Upload Servidores"
          : type == 2
          ? "Upload Aposentados"
          : "Upload Pensionistas",
      input: "file",
      inputAttributes: {
        "aria-label": "Selecione a planilha",
      },
    });

    if (!file) {
      await this.app.alert(
        "Atenção!",
        "Você deve informar uma planilha!",
        "error"
      );
      return;
    }

    if (!file.name.endsWith("csv")) {
      await this.app.alert(
        "Atenção!",
        "Você deve informar planilhas no formato .csv!",
        "error"
      );
      return;
    }
    const reader = new FileReader();
    reader.onload = async () => {
      let text = reader.result;
      let csvJson = self.csvJSON(text);
      let lista = JSON.parse(csvJson);
      let newLista = [];
      for (let l of lista) {
        // @ts-ignore
        const trimmed = Object.entries(l).reduce((acc, curr) => {
          let [key, value] = curr;
          // Checking if the key is a string
          acc[typeof key === "string" ? key.trim() : key] = value;
          return acc;
        }, {});
        newLista.push(trimmed);
      }
      lista = [...newLista];
      let cols = lista ? Object.keys(lista[0]) : [];
      let totalCol = lista ? Object.keys(lista[0]).length : 0;
      let totalDeLinhas = lista.length;
      let tipo = file.type;
      let extension = file.name.split(".").pop().toLowerCase();
      const uploadFiles = await this.apiCall
        .post("servidor/arquivo/exact/url", {
          extension: file.name,
          type: tipo,
        })
        .pipe(take(1))
        .toPromise();

      //total de colunas
      //se tem todas colunas esperadas
      //se colunas de data tem data
      //se contem somente 1 codigo ibge na tabela
      //se codigo ibge corresponde com a cidade corrente

      if (type == 1) {
        if (totalCol != 41) {
          await this.app.alert(
            "Atenção!",
            "Quantidade de colunas do seu arquivo é diferente da esperada!",
            "error"
          );
          return;
        }
        const array2Sorted = this.colunasEsperadasAtivos.slice().sort();
        const isEqual =
          cols.length === this.colunasEsperadasAtivos.length &&
          cols
            .slice()
            .sort()
            .every(function (value, index) {
              return value === array2Sorted[index];
            });
        if (!isEqual) {
          await this.app.alert(
            "Atenção!",
            "O cabeçalho do seu arquivo é diferente do esperado!",
            "error"
          );
          return;
        }
      } else if (type == 2) {
        if (totalCol != 32) {
          await this.app.alert(
            "Atenção!",
            "Quantidade de colunas do seu arquivo é diferente da esperada!",
            "error"
          );
          return;
        }
        const array2Sorted = this.colunasEsperadasInativos.slice().sort();
        const isEqual =
          cols.length === this.colunasEsperadasInativos.length &&
          cols
            .slice()
            .sort()
            .every(function (value, index) {
              return value === array2Sorted[index];
            });
        if (!isEqual) {
          await this.app.alert(
            "Atenção!",
            "O cabeçalho do seu arquivo é diferente do esperado!",
            "error"
          );
          return;
        }
      } else if (type == 3) {
        if (totalCol != 24) {
          await this.app.alert(
            "Atenção!",
            "Quantidade de colunas do seu arquivo é diferente da esperada!",
            "error"
          );
          return;
        }
        const array2Sorted = this.colunasEsperadasAposentados.slice().sort();
        const isEqual =
          cols.length === this.colunasEsperadasAposentados.length &&
          cols
            .slice()
            .sort()
            .every(function (value, index) {
              return value === array2Sorted[index];
            });
        if (!isEqual) {
          await this.app.alert(
            "Atenção!",
            "O cabeçalho do seu arquivo é diferente do esperado!",
            "error"
          );
          return;
        }
      }
      let colunasDeData = cols.filter((x) => x.toString().startsWith("DT_"));
      const invalidDates = lista.filter(
        (l) =>
          colunasDeData.filter(
            (c) => l[c] && !moment(l[c], "DD/MM/YYYY").isValid()
          ).length > 0
      );
      if (invalidDates.length > 0) {
        await this.app.alert(
          "Atenção!",
          "O seu arquivo contém datas inválidas!",
          "error"
        );
        return;
      }
      let ibgeFound = [];
      for (let l of lista) {
        if (l.CO_IBGE && !ibgeFound.find((i) => i == l.CO_IBGE)) {
          ibgeFound.push(l.CO_IBGE);
        }
      }
      if (ibgeFound.length !== 1) {
        await this.app.alert(
          "Atenção!",
          "O seu arquivo contém mais de um código IBGE!",
          "error"
        );
        return;
      }
      if (self.cidade && self.cidade.ibge && ibgeFound[0] != self.cidade.ibge) {
        await this.app.alert(
          "Atenção!",
          "O seu arquivo contém código IBGE inválido! o código esperado para esta cidade é " +
            self.cidade.ibge,
          "error"
        );
        return;
      }
      if (!uploadFiles || !uploadFiles.result) {
        return;
      }
      var options = {
        headers: { "Content-Type": tipo, "x-amz-acl": "public-read" },
      };

      const resultado = await self.http
        .put<any>(uploadFiles.result.replace(".sa-east-1", ""), file, options)
        .toPromise();
      let urlArquivo = uploadFiles.result.split("?")[0];

      await self.spinner.show(undefined, {
        type: "ball-triangle-path",
        size: "medium",
        bdColor: "rgba(0, 0, 0, 0.8)",
        color: "#fff",
        fullScreen: true,
      });
      await this.apiCall
        .post(
          `servidor/arquivo/planilha?tipo=${type}&cidade=${self.idCidade}&url=${urlArquivo}&total_rows=${totalDeLinhas}`
        )
        .pipe(take(1))
        .toPromise();
      await self.app.alert(
        "Tudo certo!",
        "Planilha cadastrada com sucesso!",
        "success"
      );

      await self.spinner.hide();
      await self.ngOnInit();
    };
    reader.readAsText(file as Blob, "ISO-8859-1");
  }
  async uploadSimplificado() {
    const self = this;
    const { value: file } = await Swal.fire({
      title: "Upload Simplificado Servidores",
      input: "file",
      inputAttributes: {
        "aria-label": "Selecione a planilha",
      },
    });

    if (!file) {
      await this.app.alert(
        "Atenção!",
        "Você deve informar uma planilha!",
        "error"
      );
      return;
    }

    /*if (!file.name.endsWith("csv")) {
      await this.app.alert(
        "Atenção!",
        "Você deve informar planilhas no formato .csv!",
        "error"
      );
      return;
    }*/
    const reader = new FileReader();
    reader.onload = async () => {
      let text = reader.result;
      let csvJson = self.csvJSON(text);
      console.log(text)
      let lista = JSON.parse(csvJson);
      let newLista = [];
      for (let l of lista) {
        // @ts-ignore
        const trimmed = Object.entries(l).reduce((acc, curr) => {
          let [key, value] = curr;
          // Checking if the key is a string
          acc[typeof key === "string" ? key.trim() : key] = value;
          return acc;
        }, {});
        newLista.push(trimmed);
      }
      lista = [...newLista];
      let cols = lista ? Object.keys(lista[0]) : [];
      let totalCol = lista ? Object.keys(lista[0]).length : 0;
      let totalDeLinhas = lista.length;
      let tipo = file.type;
      let extension = file.name.split(".").pop().toLowerCase();
      const uploadFiles = await this.apiCall
        .post("servidor/arquivo/exact/url", {
          extension: file.name,
          type: tipo,
        })
        .pipe(take(1))
        .toPromise();

      //total de colunas
      //se tem todas colunas esperadas
      //se colunas de data tem data
      //se contem somente 1 codigo ibge na tabela
      //se codigo ibge corresponde com a cidade corrente

      if (totalCol != 5) {
        await this.app.alert(
          "Atenção!",
          "Quantidade de colunas do seu arquivo é diferente da esperada!",
          "error"
        );
        return;
      }
      const array2Sorted = this.colunasEsperadasSimplificado.slice().sort();
      const isEqual =
        cols.length === this.colunasEsperadasSimplificado.length &&
        cols
          .slice()
          .sort()
          .every(function (value, index) {
            return value === array2Sorted[index];
          });
      if (!isEqual) {
        await this.app.alert(
          "Atenção!",
          "O cabeçalho do seu arquivo é diferente do esperado!",
          "error"
        );
        return;
      }

      let ibgeFound = [];
      for (let l of lista) {
        if (l.CO_IBGE && !ibgeFound.find((i) => i == l.CO_IBGE)) {
          ibgeFound.push(l.CO_IBGE);
        }
      }
      if (ibgeFound.length !== 1) {
        await this.app.alert(
          "Atenção!",
          "O seu arquivo contém mais de um código IBGE!",
          "error"
        );
        return;
      }
      if (self.cidade && self.cidade.ibge && ibgeFound[0] != self.cidade.ibge) {
        await this.app.alert(
          "Atenção!",
          "O seu arquivo contém código IBGE inválido! o código esperado para esta cidade é " +
            self.cidade.ibge,
          "error"
        );
        return;
      }
      if (!uploadFiles || !uploadFiles.result) {
        return;
      }
      var options = {
        headers: { "Content-Type": tipo, "x-amz-acl": "public-read" },
      };

      const resultado = await self.http
        .put<any>(uploadFiles.result.replace(".sa-east-1", ""), file, options)
        .toPromise();
      let urlArquivo = uploadFiles.result.split("?")[0];

      await self.spinner.show(undefined, {
        type: "ball-triangle-path",
        size: "medium",
        bdColor: "rgba(0, 0, 0, 0.8)",
        color: "#fff",
        fullScreen: true,
      });
      await this.apiCall
        .post(
          `servidor/arquivo/planilha?tipo=${9}&cidade=${self.idCidade}&url=${urlArquivo}&total_rows=${totalDeLinhas}&simplificada=true`
        )
        .pipe(take(1))
        .toPromise();
      await self.app.alert(
        "Tudo certo!",
        "Planilha cadastrada com sucesso!",
        "success"
      );
      await self.spinner.hide();
      await self.ngOnInit();
    };
    reader.readAsText(file as Blob, "ISO-8859-1");
  }
  async uploadIdadeAposentadoria() {
    const self = this;
    const { value: file } = await Swal.fire({
      title: "Upload Planilha Idade Aposentadoria",
      input: "file",
      inputAttributes: {
        "aria-label": "Selecione a planilha",
      },
    });

    if (!file) {
      await this.app.alert(
        "Atenção!",
        "Você deve informar uma planilha!",
        "error"
      );
      return;
    }

    if (!file.name.endsWith("csv")) {
      await this.app.alert(
        "Atenção!",
        "Você deve informar planilhas no formato .csv!",
        "error"
      );
      return;
    }
    const reader = new FileReader();
    reader.onload = async () => {
      let text = reader.result;
      let csvJson = self.csvJSON(text);

      let lista = JSON.parse(csvJson);
      let newLista = [];
      for (let l of lista) {
        // @ts-ignore
        const trimmed = Object.entries(l).reduce((acc, curr) => {
          let [key, value] = curr;
          // Checking if the key is a string
          acc[typeof key === "string" ? key.trim() : key] = value;
          return acc;
        }, {});
        newLista.push(trimmed);
      }
      lista = [...newLista];
      let cols = lista ? Object.keys(lista[0]) : [];
      let totalCol = lista ? Object.keys(lista[0]).length : 0;
      let totalDeLinhas = lista.length;
      let tipo = file.type;
      let extension = file.name.split(".").pop().toLowerCase();
      const uploadFiles = await this.apiCall
        .post("servidor/arquivo/exact/url", {
          extension: file.name,
          type: tipo,
        })
        .pipe(take(1))
        .toPromise();

      if (totalCol != 3) {
        await this.app.alert(
          "Atenção!",
          "Quantidade de colunas do seu arquivo é diferente da esperada!",
          "error"
        );
        return;
      }
      const array2Sorted = this.colunasEsperadasIdadeAposentadoria.slice().sort();
      const isEqual =
        cols.length === this.colunasEsperadasIdadeAposentadoria.length &&
        cols
          .slice()
          .sort()
          .every(function (value, index) {
            return value === array2Sorted[index];
          });
      if (!isEqual) {
        await this.app.alert(
          "Atenção!",
          "O cabeçalho do seu arquivo é diferente do esperado!",
          "error"
        );
        return;
      }

      let ibgeFound = [];
      for (let l of lista) {
        if (l.CO_IBGE && !ibgeFound.find((i) => i == l.CO_IBGE)) {
          ibgeFound.push(l.CO_IBGE);
        }
      }
      if (ibgeFound.length !== 1) {
        await this.app.alert(
          "Atenção!",
          "O seu arquivo contém mais de um código IBGE!",
          "error"
        );
        return;
      }
      if (self.cidade && self.cidade.ibge && ibgeFound[0] != self.cidade.ibge) {
        await this.app.alert(
          "Atenção!",
          "O seu arquivo contém código IBGE inválido! o código esperado para esta cidade é " +
            self.cidade.ibge,
          "error"
        );
        return;
      }
      if (!uploadFiles || !uploadFiles.result) {
        return;
      }
      var options = {
        headers: { "Content-Type": tipo, "x-amz-acl": "public-read" },
      };

      const resultado = await self.http
        .put<any>(uploadFiles.result.replace(".sa-east-1", ""), file, options)
        .toPromise();
      let urlArquivo = uploadFiles.result.split("?")[0];

      await self.spinner.show(undefined, {
        type: "ball-triangle-path",
        size: "medium",
        bdColor: "rgba(0, 0, 0, 0.8)",
        color: "#fff",
        fullScreen: true,
      });
      await this.apiCall
        .post(
          `servidor/arquivo/planilha?tipo=${8}&cidade=${self.idCidade}&url=${urlArquivo}&total_rows=${totalDeLinhas}`
        )
        .pipe(take(1))
        .toPromise();
      await self.app.alert(
        "Tudo certo!",
        "Planilha cadastrada com sucesso!",
        "success"
      );
      await self.spinner.hide();
      await self.ngOnInit();
    };
    reader.readAsText(file as Blob, "ISO-8859-1");
  }
  async alterarStatusServidor(id, ativo) {
    if (ativo) {
      ativo = 0;
    } else {
      ativo = 1;
    }
    const deleteDependente = await this.apiCall
      .get(`servidor/atualiza-status?id_servidor=${id}&ativo=${ativo}`)
      .pipe(take(1))
      .toPromise();
    this.ngOnInit();
  }
  async deletarServidor(servidor) {
    const self = this;
    if (
      await self.app.confirm(
        `Atenção`,
        `Você deseja excluir esta linha? Se for a última matrícula, o cadastro do servidor também será excluído.`,
        `Excluir`
      )
    ) {
      self.spinner.show(undefined, {
        type: "ball-triangle-path",
        size: "medium",
        bdColor: "rgba(0, 0, 0, 0.8)",
        color: "#fff",
        fullScreen: true,
      });
      const idMovimento = servidor.id_movimento_funcional;
      const url = `servidor/deletar-linha?id_servidor=${servidor.id}` +
        (idMovimento != null ? `&id_movimento=${idMovimento}` : '');
      let retorno;
      try {
        retorno = await self.apiCall.get(url).pipe(take(1)).toPromise();
      } catch (error) {
        await self.spinner.hide();
        await self.app.alert(`Erro`, error && error.error && error.error.message
          ? error.error.message : `Não foi possível excluir este registro.`, `error`);
        return;
      }
      await self.spinner.hide();
      await self.app.alert(`Sucesso`, retorno && retorno.message
        ? retorno.message : `Registro excluído!`, `success`);
      await self.ngOnInit();
    }
  }
  async removerMatricula(servidor: any, matricula: any) {
    const self = this;
    const numeroMatricula = matricula && matricula.matricula
      ? ` ${matricula.matricula}` : '';
    const ultimaMatricula = self.getMatriculasServidor(servidor).length === 1;
    const mensagem = ultimaMatricula
      ? `A matrícula${numeroMatricula} é a última deste servidor. Ao removê-la, o cadastro do servidor também será excluído. Deseja continuar?`
      : `Você deseja remover a matrícula${numeroMatricula} e todos os dados vinculados a ela?`;

    if (!await self.app.confirm(`Atenção`, mensagem, `Remover`)) {
      return;
    }

    self.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });

    try {
      const retorno = await self.apiCall
        .get(`servidor/deletar-linha?id_servidor=${servidor.id}&id_matricula=${matricula.id}`)
        .pipe(take(1))
        .toPromise();
      await self.spinner.hide();
      await self.app.alert(`Sucesso`, retorno && retorno.message
        ? retorno.message : `Matrícula removida com sucesso!`, `success`);
      await self.loadServidores();
    } catch (error) {
      await self.spinner.hide();
      await self.app.alert(`Erro`, error && error.error && error.error.message
        ? error.error.message : `Não foi possível remover a matrícula.`, `error`);
    }
  }
  async getRelatorioTempoServicoPassado() {
    const self = this;

    let tempos = [];

    if (!self.idCidade) {
      return;
    }
    await self.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    const servidores = await self.apiCall
      .get("servidor/relatorio/tempo?id_cidade=" + self.idCidade)
      .pipe(take(1))
      .toPromise();
    console.log(servidores);
    for (let i in servidores) {
      const servidor = servidores[i];
      let data = {
        NOME_SERVIDOR: servidor.nome,
        CPF_CNPJ_EMPREGADOR: servidor.cnpj_cpf_empregador,
        DATA_INICIO: servidor.data_entrada,
        DATA_FIM: servidor.data_fim,
        TEMPO_BRUTO: servidor.tempo_bruto,
        NUMERO_CERTIDAO: servidor.numero_certidao,
        DATA_CERTIDAO: servidor.data_certidao,
      };
      tempos.push(data);
    }
    await self.spinner.hide();
    self.excelService.exportAsExcelFile(
      JSON.parse(JSON.stringify(tempos)),
      "servidores_tempo_passado"
    );
  }
  async getRelatorioAtendimento() {
    const self = this;


    if (!self.idCidade) {
      return;
    }
    await self.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    const servidores = await self.apiCall
      .get("servidor/atendimento/relatorio?id_cidade=" + self.idCidade)
      .pipe(take(1))
      .toPromise();
    console.log('servidores', servidores)

    await self.spinner.hide();
    self.excelService.exportAsExcelFile(
      JSON.parse(JSON.stringify(servidores ? servidores : [])),
      "servidores_atendimento"
    );
  }

  async getRelatoriosCidade() {
    const self = this;

    let servidoresAtivos = [];
    let servidoresPensionistas = [];
    let servidoresAposentados = [];
    if (!self.idCidade) {
      return;
    }
    await self.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    console.log("1");
    const servidores = await self.apiCall
      .get("servidor/relatorio/cidade?id_cidade=" + self.idCidade)
      .pipe(take(1))
      .toPromise();
    for (let i in servidores) {
      const servidor = servidores[i];
      //if ( servidor.status == '1' || (!servidor.status && servidor.statusServidor == "1")) {
      if ( servidor.status == '1') {
        let data = {
          NU_ANO: servidor.ano,
          CO_IBGE: servidor.ibge,
          NO_ENTE: servidor.cidade,
          SG_UF: servidor.estado,
          CO_COMP_MASSA: "1",
          CO_TIPO_FUNDO: "1",
          NU_CNPJ_ORGAO: servidor.cnpj,
          NO_ORGAO: servidor.orgao,
          CO_PODER: servidor.poder,
          CO_TIPO_PODER: "",
          CO_TIPO_POPULACAO: "1",
          CO_TIPO_CARGO: "",
          CO_CRITERIO_ELEGIBILIDADE: "",
          ID_SERVIDOR_MATRICULA: servidor.matricula,
          ID_SERVIDOR_CPF: servidor.cpf,
          ID_SERVIDOR_PIS_PASEP: servidor.pis,
          CO_SEXO_SERVIDOR: servidor.sexo,
          CO_EST_CIVIL_SERVIDOR: servidor.estadoCivil,
          DT_NASC_SERVIDOR: servidor.dataNascimento,
          CO_SITUACAO_FUNCIONAL: "1",
          CO_TIPO_VINCULO: "1",
          DT_ING_SERV_PUB: servidor.dataIngressoServicoPublico,
          DT_ING_ENTE: servidor.dataIngressoEnte,
          DT_ING_CARREIRA: servidor.dataIngressoCarreiraAtual,
          NO_CARREIRA: servidor.carreiraAtual,
          DT_ING_CARGO: servidor.dataInicioCargoAtual,
          NO_CARGO: servidor.cargoAtual,
          VL_BASE_CALCULO: servidor.salarioBaseMensal,
          VL_REMUNERACAO: servidor.salarioTotal,
          NU_TEMPO_RGPS: servidor.tempoServicoAnteriorTotalRgps,
          NU_TEMPO_RPPS: servidor.tempoServicoAnteriorTotalRpps,
          NU_DEPENDENTES: servidor.totalDependentes,
          DT_NASC_CONJUGE: servidor.dataNascimentoConjuge,
          CO_COND_CONJUGE: "1",
          DT_NASC_DEPENDENTE_1: servidor.dataNascimentoDependente2,
          CO_COND_DEPENDENTE_1: "1",
          DT_NASC_DEPENDENTE_2: servidor.dataNascimentoDependente3,
          CO_COND_DEPENDENTE_2: "1",
          "IN_ABONO_PERMANENCIA ": "",
          DT_INICIO_ABONO: "",
          DT_PROV_APOSENT: "",
        };
        servidoresAtivos.push(data);
     // } else if (servidor.status == '3' || (!servidor.status && servidor.statusServidor == "4")) {
      } else if (servidor.status == '3') {
        if(servidor.cpf && servidor.cpf.startsWith('607') )console.log('servidor pensionista', servidor)
        let data = {
          NU_ANO: servidor.ano,
          CO_IBGE: servidor.ibge,
          NO_ENTE: servidor.cidade,
          SG_UF: servidor.estado,
          CO_COMP_MASSA: "1",
          CO_TIPO_FUNDO: "1",
          CNPJ_ORGAO: servidor.cnpj,
          NO_ORGAO: servidor.orgao,
          CO_PODER: servidor.poder,
          CO_TIPO_PODER: "",
          CO_TIPO_INSTITUIDOR: "",
          ID_INSTITUIDOR_MATRICULA: "",
          ID_INSTITUIDOR_CPF: "",
          ID_INSTITUIDOR_PIS_PASEP: "",
          ID_PENSIONISTA_CPF: servidor.cpf,
          CO_SEXO_PENSIONISTA: servidor.sexo,
          DT_NASC_PENSIONISTA: servidor.dataNascimento,
          DT_INICIO_PENSAO: servidor.dataIngressoCarreiraAtual,
          VL_BENEF_PENSAO: servidor.salarioBaseMensal,
          VL_CONTRIBUICAO: "",
          VL_COMPENS_PREVID: "",
          IN_PARID_SERV: "",
          CO_CONDICAO: "",
          CO_DURACAO: "",
        };
        servidoresPensionistas.push(data);
     // } else if (servidor.status == '2' || (!servidor.status && servidor.statusServidor == "3")) {
      } else if (servidor.status == '2') {
        console.log('servidor aposentado', servidor)
        let data = {
          NU_ANO: servidor.ano,
          CO_IBGE: servidor.ibge,
          NO_ENTE: servidor.cidade,
          SG_UF: servidor.estado,
          CO_COMP_MASSA: "1",
          CO_TIPO_FUNDO: "1",
          CNPJ_ORGAO: servidor.cnpj,
          NO_ORGAO: servidor.orgao,
          CO_PODER: servidor.poder,
          CO_TIPO_PODER: "",
          CO_TIPO_POPULACAO: "4",
          CO_TIPO_CARGO: "",
          CO_TIPO_APOSENTADORIA: "",
          ID_APOSENTADO_MATRICULA: servidor.matricula,
          ID_APOSENTADO_CPF: servidor.cpf,
          ID_APOSENT_PIS_PASEP: servidor.pis,
          CO_SEXO_APOSENTADO: servidor.sexo,
          CO_EST_CIVIL_APOSENTADO: servidor.estadoCivil,
          DT_NASC_APOSENTADO: servidor.dataNascimento,
          DT_INICIO_APOSENTADORIA: servidor.dataIngressoCarreiraAtual,
          VL_APOSENTADORIA: servidor.salarioBaseMensal,
          VL_CONTRIBUICAO: "",
          IN_PARID_SERV: "",
          CO_CONDICAO_APOSENTADO: "",
          VL_COMPENS_PREVID: "",
          NU_DEPENDENTES: servidor.totalDependentes,
          DT_NASC_CONJUGE: servidor.dataNascimentoConjuge,
          CO_CONDICAO_CONJUGE: "1",
          DT_NASC_DEPENDENTE_1: servidor.dataNascimentoDependente2,
          CO_CONDICAO_DEPENDENTE_1: "1",
          DT_NASC_DEPENDENTE_2: servidor.dataNascimentoDependente3,
          CO_CONDICAO_DEPENDENTE_2: "1",
        };
        servidoresAposentados.push(data);
      }
    }
    self.excelService.exportAsExcelFile(
      JSON.parse(JSON.stringify(servidoresAtivos)),
      "servidores"
    );
    self.excelService.exportAsExcelFile(
      JSON.parse(JSON.stringify(servidoresAposentados)),
      "aposentados"
    );
    self.excelService.exportAsExcelFile(
      JSON.parse(JSON.stringify(servidoresPensionistas)),
      "pensionistas"
    );
    self.spinner.hide();
  }


  async getRelatorioPendencias() {
    const self = this;

    let lista = [];
    if (!self.idCidade) {
      return;
    }
    await self.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    const servidores = await self.apiCall
      .get("servidor/relatorio/cidade/pendencias?id_cidade=" + self.idCidade)
      .pipe(take(1))
      .toPromise();
    for (let i in servidores) {
      const servidor = servidores[i];
      if(servidor.pendencias){
        let data = {
          NOME: servidor.nome,
          STATUS: (servidor.statusServidor == "1" || servidor.status == '1') ? 'Ativo' : (servidor.statusServidor == "4"  || servidor.status == '3') ? 'Pensionista' : (servidor.statusServidor == "3"  || servidor.status == '2') ? 'Aposentado' : servidor.status == '4' ? 'Exonerado' : '',
          'PENDÊNCIA': servidor.pendencias,
          'OBSERVAÇÃO': servidor.observacoes,
        };
        lista.push(data)
      }
    }
    self.excelService.exportAsExcelFile(
      JSON.parse(JSON.stringify(lista)),
      "servidores"
    );
    self.spinner.hide();
  }
  async toggleEstado() {
    if (!this.servidor.estado_naturalidade) {
      return;
    }
    this.cidades = [];
    const cidades = await this.apiCall
      .get(
        "enderecos/estados/cidades?estado=" + this.servidor.estado_naturalidade
      )
      .pipe(take(1))
      .toPromise();
    this.cidades = JSON.parse(JSON.stringify(cidades));
  }

  filter() {
    this.servidoresFiltered = this.servidores;
    if (this.filterName) {
      this.servidoresFiltered = this.servidoresFiltered.filter(
        (x) =>
          x.nome && x.nome.toLowerCase().includes(this.filterName.toLowerCase())
      );
    }
    if (this.filterCpf) {
      this.servidoresFiltered = this.servidoresFiltered.filter(
        (x) =>
          x.cpf && x.cpf.toLowerCase().includes(this.filterCpf.toLowerCase())
      );
    }
    if (this.filterMatricula) {
      this.servidoresFiltered = this.servidoresFiltered.filter(
        (x) =>
          x.matricula &&
          x.matricula.toLowerCase().includes(this.filterMatricula.toLowerCase()
          )
      );
    }
    if (this.filterNascimento) {
      this.servidoresFiltered = this.servidoresFiltered.filter(
        (x) =>
          x.data_nascimento &&
          moment
            .utc(x.data_nascimento)
            .format("DDMMYYYY")
            .toLowerCase()
            .includes(this.filterNascimento.toLowerCase())
      );
    }
    if (this.filterCadastro) {
      this.servidoresFiltered = this.servidoresFiltered.filter(
        (x) =>
          x.data_inclusao &&
          moment
            .utc(x.data_inclusao)
            .format("DDMMYYYY")
            .toLowerCase()
            .includes(this.filterCadastro.toLowerCase())
      );
    }
    if (this.filterSexo && this.filterSexo.id) {
      this.servidoresFiltered = this.servidoresFiltered.filter(
        (x) => x.sexo && x.sexo == this.filterSexo.id
      );
    }
    if (this.filterStatus) {
      this.servidoresFiltered = this.servidoresFiltered.filter(
        (x) => x.status && x.status == this.filterStatus
      );
    }
  }

  beautifulDate(date) {
    if (!date) return null;
    // Se a data contém informação de hora, formata com hora
    if (typeof date === 'string' && date.includes(':')) {
      return moment(date).format("DD/MM/YYYY - HH:mm:ss");
    }
    // Senão, formata apenas a data
    return moment.utc(date).format("DD/MM/YYYY");
  }

  beautifulDateSimple(date) {
    if (!date) return null;
    return moment.utc(date).format("DD/MM/YYYY");
  }

  disableServidor() {
    const self = this;
    if(!self.servidor.nome ||
      !self.servidor.status){
        return true;
      } else {
        return false;
      }

    // if (self.servidor.status && self.servidor.status == 1) {
    //   if (
    //     !self.servidor.nome ||
    //     !self.servidor.status ||
    //     !self.servidor.deficiente ||
    //     !self.servidor.escolaridade ||
    //     !self.servidor.nome_mae ||
    //     !self.servidor.nome_pai ||
    //     !self.servidor.naturalizado ||
    //     !self.servidor.nacionalidade ||
    //     !self.servidor.cidade_naturalidade ||
    //     !self.servidor.estado_civil ||
    //     !self.servidor.sexo ||
    //     !self.servidor.estado_naturalidade ||
    //     !self.servidor.data_nascimento
    //   ) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // }
    // if (self.servidor.status && self.servidor.status == 2) {
    //   if (
    //     !self.servidor.nome ||
    //     !self.servidor.status ||
    //     !self.servidor.deficiente ||
    //     !self.servidor.escolaridade ||
    //     !self.servidor.nome_mae ||
    //     !self.servidor.nome_pai ||
    //     !self.servidor.naturalizado ||
    //     !self.servidor.nacionalidade ||
    //     !self.servidor.cidade_naturalidade ||
    //     !self.servidor.estado_civil ||
    //     !self.servidor.sexo ||
    //     !self.servidor.estado_naturalidade ||
    //     !self.servidor.data_nascimento
    //   ) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // } else if (self.servidor.status) {
    //   if (
    //     (self.servidor.status==3 && !self.servidor.cpf_pensao) ||
    //     (self.servidor.status==3 && !self.servidor.nome_pensao) ||
    //     !self.servidor.nome ||
    //     !self.servidor.status ||
    //     !self.servidor.deficiente ||
    //     !self.servidor.escolaridade ||
    //     !self.servidor.nome_mae ||
    //     !self.servidor.nome_pai ||
    //     !self.servidor.naturalizado ||
    //     !self.servidor.nacionalidade ||
    //     !self.servidor.cidade_naturalidade ||
    //     !self.servidor.estado_civil ||
    //     !self.servidor.sexo ||
    //     !self.servidor.estado_naturalidade ||
    //     !self.servidor.data_nascimento
    //   ) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // } else {
    //   return false;
    // }
  }
  async cadastrarServidor(modal) {
    const self = this;
    const dadosUsuario = this.me.currentUserValue;
    const json = JSON.parse(JSON.stringify(dadosUsuario));
    const cidade = this.idCidade || json.user.cidade;
    const payload: any = {
      ...self.servidor,
      id_cidade: cidade,
      nome: self.servidor.nome ? String(self.servidor.nome).trim() : '',
      matricula: self.servidor.matricula
        ? String(self.servidor.matricula).trim()
        : '',
      data_nascimento: this.preparaData(self.servidor.data_nascimento),
      data_ingresso_servico_publico: this.preparaData(
        self.servidor.data_ingresso_servico_publico
      ),
      concessao_aposentadoria: this.preparaData(
        self.servidor.concessao_aposentadoria
      ),
      data_falecimento_pensao: this.preparaData(
        self.servidor.data_falecimento_pensao
      ),
      data_nascimento_pensao: this.preparaData(
        self.servidor.data_nascimento_pensao
      ),
    };

    if (payload.valor_aposentadoria) {
      payload.valor_aposentadoria = payload.valor_aposentadoria
        .toString()
        .replace(".", "")
        .replace(",", ".");
    }
    if (payload.valor_beneficio) {
      payload.valor_beneficio = payload.valor_beneficio
        .toString()
        .replace(".", "")
        .replace(",", ".");
    }

    self.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });

    try {
      const resposta: any = await this.apiCall
        .post('servidor/novo', payload)
        .pipe(take(1))
        .toPromise();

      if (!resposta || +resposta.status >= 400 || !resposta.insertId) {
        const erro = resposta && resposta.error;
        const mensagem = (erro && (erro.message || erro)) ||
          (resposta && resposta.message) ||
          'Não foi possível cadastrar o servidor.';
        await this.app.alert("Erro!", String(mensagem), "error");
        return;
      }

      let cpfCadastrado = true;
      if (self.servidor.cpf) {
        const documentos: any = await self.apiCall
          .get(
            `servidor/documentos/novo?id_servidor=${resposta.insertId}&cpf=${self.servidor.cpf}&nit=&rg=&data_emissao_rg=&orgao_expedidor_rg=1&uf_rg=&cpts=&serie_cpts=&data_emissao_cpts=&titulo_eleitor=&zona_titulo_eleitor=&secao_titulo_eleitor=&uf_titulo_eleitor=`
          )
          .pipe(take(1))
          .toPromise();
        cpfCadastrado = !!documentos && !(+documentos.status >= 400);
      }

      await this.app.alert(
        cpfCadastrado ? "Tudo certo!" : "Atenção!",
        cpfCadastrado
          ? "Servidor cadastrado com sucesso!"
          : "Servidor cadastrado, mas não foi possível salvar o CPF. Complete os documentos na ficha.",
        cpfCadastrado ? "success" : "warning"
      );
      await this.ngOnInit();
      modal.close("Close click");
    } catch (erro) {
      const detalhe = erro && (erro.message || erro.error);
      await this.app.alert(
        "Erro!",
        detalhe ? String(detalhe) : "Não foi possível cadastrar o servidor.",
        "error"
      );
    } finally {
      self.spinner.hide();
    }
  }

  preparaData(data) {
    if (data) {
      return moment(data, "DDMMYYYY").format("YYYY-MM-DD");
    } else {
      data = "";
    }
    return data;
  }

  validateQuotes(str) {
    if (str) {
      return str.replace("'", "'");
    } else {
      return "";
    }
  }

  async getRelatorioServidor(content, id) {
    const self = this;
    const servidor = await self.apiCall.get(`servidor?id=${id}&id_cidade=${self.idCidade}`).pipe(take(1)).toPromise()
    self.servidor = JSON.parse(JSON.stringify(servidor));
    const serv = await self.apiCall
    .get("servidor/relatorio/servidor?id=" + id)
    .pipe(take(1))
    .toPromise();
    const escolaridades = await self.apiCall
      .get("servidor/escolaridade")
      .pipe(take(1))
      .toPromise();
    const estadosCivis = await self.apiCall
      .get("servidor/estadocivil")
      .pipe(take(1))
      .toPromise();
    const dependentes = await self.apiCall.get(`servidor/dependente/todos?id_servidor=${id}`).pipe(take(1)).toPromise();
    const tiposDependencia = await self.apiCall.get('servidor/tiposdependencia').pipe(take(1)).toPromise();


    self.tiposDependencia = JSON.parse(JSON.stringify(tiposDependencia));
    self.dependentes = JSON.parse(JSON.stringify(dependentes));
    self.estadosCivis = JSON.parse(JSON.stringify(estadosCivis));
    self.escolaridades = JSON.parse(JSON.stringify(escolaridades));
    var servidorFilter = this.servidoresFiltered.filter(x => x['id'] == id);
    this.servidor = JSON.parse(JSON.stringify(servidorFilter[0]));
    var estadoCivil = this.estadosCivis.filter(x => x['id'] == servidorFilter[0]?.['estado_civil']);
    var escolaridade = this.escolaridades.filter(x => x['id'] == servidorFilter[0]?.['escolaridade']);

    // Usar o servidor completo da lista filtrada que contém todos os dados
    const servidorCompleto = MatriculaServidorHelper.normalizarServidor(servidorFilter[0], this.idCidade);
    
    // Definir status como string para exibição
    this.servidor.status = this.classificaStatus(servidorCompleto.status);
    
    // Definir salário/benefício baseado no status real (não string)
    if (servidorCompleto.status == 1) {
      // Servidor Ativo: usa salario_base
      this.servidor.salario = servidorCompleto.salario_base || null;
    } else if (servidorCompleto.status == 2) {
      // Aposentado: usa valor_aposentadoria
      this.servidor.salario = servidorCompleto.valor_aposentadoria || null;
    } else if (servidorCompleto.status == 3) {
      // Pensionista: usa valor_beneficio
      this.servidor.salario = servidorCompleto.valor_beneficio || null;
    } else {
      this.servidor.salario = null;
    }
    
    // Copiar todos os dados do servidor completo
    this.servidor.nome = servidorCompleto.nome || serv.nome;
    this.servidor.imagem = servidorCompleto.imagem || serv.imagem;
    this.servidor.cpf = servidorCompleto.cpf || serv.cpf;
    this.servidor.rg = serv.rg;
    this.servidor.matricula = MatriculaServidorHelper.getMatriculaDisplay(servidorCompleto);
    this.servidor.telefone = serv.telefone;
    this.servidor.naturalizado = servidorCompleto.naturalizado == 1 ? 'Sim' : (servidorCompleto.naturalizado == 2 ? 'Não' : null);
    this.servidor.estado_civil = estadoCivil[0]?.['descricao'] || null;
    this.servidor.carga_horaria = serv.carga_horaria || null;
    
    // Cargo: para ativo usa cargo, para aposentado usa cargo_aposentadoria
    if (servidorCompleto.status == 1) {
      this.servidor.cargo = servidorCompleto.cargo || serv.cargo || null;
    } else if (servidorCompleto.status == 2) {
      this.servidor.cargo = servidorCompleto.cargo_aposentadoria || null;
    } else {
      this.servidor.cargo = null;
    }
    
    this.servidor.escolaridade = escolaridade[0]?.['descricao'] || null;
    
    // Dados específicos de aposentado
    this.servidor.valor_aposentadoria = servidorCompleto.valor_aposentadoria || null;
    this.servidor.cargo_aposentadoria = servidorCompleto.cargo_aposentadoria || null;
    this.servidor.concessao_aposentadoria = servidorCompleto.concessao_aposentadoria || null;
    this.servidor.data_ingresso_servico_publico = servidorCompleto.data_ingresso_servico_publico || servidorCompleto.data_ingresso_serv || null;
    this.servidor.data_ingresso_ente = servidorCompleto.data_ingresso_ente || null;
    
    // Dados específicos de pensionista
    this.servidor.valor_beneficio = servidorCompleto.valor_beneficio || null;
    this.servidor.nome_pensao = servidorCompleto.nome_pensao || null;
    
    // Manter o status numérico para lógica condicional no HTML
    this.servidor.statusNumero = servidorCompleto.status;

    self.dependentesToShow = JSON.parse(JSON.stringify(dependentes));

    // Resetar tempos antes de calcular
    self.tempoTotalCadastrado = 0;
    self.tempoFiltradoCadastrado = 0;
    self.tempos = [];

    const tempos = await self.apiCall.get('servidor/temposervico/todos?id_servidor='+id).pipe(take(1)).toPromise()
    for(let item of JSON.parse(JSON.stringify(tempos))){
      self.tempoTotalCadastrado = self.tempoTotalCadastrado + +item.tempo_bruto
      if(/*self.tipo=='1' &&*/ item.rpps_rgps!=null && item.rpps_rgps == 0){
        self.tempos.push(item)
        self.tempoFiltradoCadastrado = self.tempoFiltradoCadastrado + +item.tempo_bruto
      }else if(/*self.tipo=='2' &&*/ (item.rpps_rgps==null || item.rpps_rgps == 1)){
        self.tempos.push(item)
        self.tempoFiltradoCadastrado = self.tempoFiltradoCadastrado + +item.tempo_bruto
      }
    }

    for(let i in self.dependentesToShow){
      if(self.dependentesToShow[i].tipo_dependencia){
        if(self.tiposDependencia.find(x => x.codigo == +self.dependentesToShow[i].tipo_dependencia)) self.dependentesToShow[i].tipo_dependencia_label = self.tiposDependencia.find(x => x.codigo == +self.dependentesToShow[i].tipo_dependencia).descricao
      }
      if(self.dependentesToShow[i].data_nascimento){
        self.dependentesToShow[i].idade = moment().diff(moment(self.dependentesToShow[i].data_nascimento), 'years')
      }
      if(self.dependentesToShow[i].inicio_dependencia) self.dependentesToShow[i].inicio_dependencia = moment(self.dependentesToShow[i].inicio_dependencia).format('DDMMYYYY')
      console.log(  self.dependentesToShow[i].inicio_dependencia, 'aq')

    }

    console.log('123', self.dependentesToShow);

    this.modalService.open(content, { centered: true, size: 'xl' });
  }
  generatePDF(id: string) {
     var printContents = document.getElementById(id).innerHTML;
			var originalContents = document.body.innerHTML;
			document.body.innerHTML = printContents;
			window.print();
			document.body.innerHTML = originalContents;

  }
  closeModal() {
    this.modalService.dismissAll();
  }

  sortTable(column: string) {
    // Atualizar coluna e direção de ordenação
    if (this.sortColumn === column) {
      // Se clicou na mesma coluna, inverte a direção
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      // Se clicou em coluna diferente, define como ascendente
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }
  
    // Resetar para primeira página quando ordenar
    this.page = 1;
    
    // Recarregar dados do backend com nova ordenação
    this.loadServidores();
  }


  isColumnSorted(column: string): boolean {
    return this.sortColumn === column;
  }

  getSortIcon(column: string): string {
    if (this.sortColumn === column) {
      return this.sortDirection === 'asc' ? 'fa-caret-up' : 'fa-caret-down';
    }
    return '';
  }


  applyFilters() {
    // Limpar timeout anterior se existir
    if (this.filterTimeout) {
      clearTimeout(this.filterTimeout);
    }

    // Normalizar filtros
    if (this.filterMatricula) {
      this.filterMatricula = this.filterMatricula.toString().trim();
    }

    // Normalizar datas: se vierem strings vazias, define como string vazia
    // (não como null, pois o backend aceita apenas inicio ou apenas fim)
    if (this.filterCreatedAt.start && !this.filterCreatedAt.start.trim()) {
      this.filterCreatedAt.start = '';
    }
    if (this.filterCreatedAt.end && !this.filterCreatedAt.end.trim()) {
      this.filterCreatedAt.end = '';
    }
    if (this.filterBirthDate.start && !this.filterBirthDate.start.trim()) {
      this.filterBirthDate.start = '';
    }
    if (this.filterBirthDate.end && !this.filterBirthDate.end.trim()) {
      this.filterBirthDate.end = '';
    }

    // Resetar para primeira página quando aplicar filtros
    this.page = 1;

    // Debounce: aguardar 500ms antes de fazer a requisição
    this.filterTimeout = setTimeout(() => {
      this.loadServidores();
    }, 500);
  }
  
  
  

  clearFilters() {
    // Reseta os campos do objeto de filtro
    this.filterName = null;
    this.filterCpf = null;
    this.filterMatricula = null;
    this.filterNascimento = null;
    this.filterCadastro = null;
    this.filterSexo = null;
    this.filterStatus = null;
    this.filterCreatedAt = {
      start: '',
      end: ''
    };
    this.filterBirthDate = {
      start: '',
      end: ''
    };
    this.filterDiverso = null;
    // Reseta a página para a primeira
    this.page = 1;

    // Recarrega servidores sem filtros
    this.loadServidores();
  }

  /**
   * Método chamado quando a página muda na paginação
   */
  onPageChange() {
    this.loadServidores();
  }

  formatToBRLCurrency(value: number | null | undefined): string {
    if (!value && value !== 0) {
      return '';
    }
    if (typeof value !== "number") {
      return '';
    }
    return value.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  }

}
